import { Component, inject, Input, OnInit } from '@angular/core';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import { getIsExperienceEditorActive } from '@core/jss-routing';
import { getDroplinkValue, mockForXp } from '@core/jss-utils';
import { Store } from '@ngrx/store';
import { reviewActions, selectReviewsWithStatistics } from '@reviews/entity';
import type {
  GetReviewsResponseWithStatistics,
  GetReviewsV1Data,
} from '@integration/api-client/reviews';
import type { LegacyReviewsComponentRendering } from '@reviews/models';
import { AsyncPipe } from '@angular/common';
import { TrackImpressionDirective } from '@analytics/events';
import { ReviewScoreComponent } from '@reviews/ui/score';
import { ReviewSingleComponent } from '@reviews/ui/single';

import { mockReviewsWithStatistics } from '../reviews.mock';

@Component({
  selector: 'wl-review-entry-legacy-container',
  templateUrl: './review-entry-container.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    TrackImpressionDirective,
    ReviewScoreComponent,
    ReviewSingleComponent,
    AsyncPipe,
  ],
})
export class ReviewEntryContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: LegacyReviewsComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  readonly store$ = inject(Store);

  xpEditorActive$ = this.store$.select(getIsExperienceEditorActive);

  reviews$ = mockForXp<GetReviewsResponseWithStatistics | undefined>(
    this.xpEditorActive$,
    this.store$.select(selectReviewsWithStatistics),
    mockReviewsWithStatistics
  );

  get location() {
    const input = getDroplinkValue(this.rendering?.fields, 'reviewCategory');
    return input || undefined;
  }

  ngOnInit(): void {
    const query: GetReviewsV1Data = {
      page: 1,
      amountOfReviews: 2,
      minimumScore: 7,
      location: this.location as GetReviewsV1Data['location'],
    };

    this.store$.dispatch(
      reviewActions.getReviewsV1.requestAction({
        actionId: 'review-entry',
        payload: query,
      })
    );
  }
}
